type propsType = {
  subTitle?: string;
  title: string;
  paragraph: string;
  center?: boolean;
  icon?: string;
  // The pricing page uses its section title as the page h1.
  as?: "h1" | "h2";
};

const SectionTitle = ({
  subTitle,
  title,
  paragraph,
  icon = "/images/hero/icon-title.svg",
  as: Heading = "h2",
}: propsType) => {
  return (
    <div className="wow fadeInUp mb-16 text-center relative z-10">
      <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
        <img
          src={icon}
          alt="icon"
          width={16}
          height={16}
          className="h-4 w-4"
        />

        <span className="hero-subtitle-text"> {subTitle} </span>
      </span>
      <Heading className="text-white mb-4.5 text-2xl font-extrabold sm:text-4xl xl:text-heading-2">
        {title}
      </Heading>
      <p className="max-w-[714px] mx-auto font-medium">{paragraph}</p>
    </div>
  );
};

export default SectionTitle;
